export const TASK_DATA = [
  {
    id: 1,
    activeTab: "1",
    title: "Created By Me",
  },
  {
    id: 2,
    activeTab: "2",
    title: "Today Tasks",
  },
  {
    id: 3,
    activeTab: "3",
    title: "Delayed Tasks",
  },
  {
    id: 4,
    activeTab: "4",
    title: "Upcoming Tasks",
  },
  {
    id: 5,
    activeTab: "5",
    title: "ThisWeek Task",
  },
  {
    id: 6,
    activeTab: "6",
    title: "This Month Tasks",
  },
  {
    id: 7,
    activeTab: "7",
    title: "Assigned To Me",
  },
  {
    id: 8,
    activeTab: "8",
    title: "My Tasks",
  },
];


export const TASK_TAG_DATA = [
    {
      id: 1,
      activeTab: "9",
      title: "Notification",
    },
    {
      id: 2,
      activeTab: "10",
      title: "Newsletter",
    },
    {
      id: 3,
      activeTab: "11",
      title: "Business",
    },
    {
      id: 4,
      activeTab: "12",
      title: "Holidays",
    },
  ];